module.exports = __webpack_public_path__ + "static/media/SWSCRC1-35.436dd5ec.mp3";